<template>
  <div>
    <v-dialog width="450" v-model="searchModal">
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-2">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-magnify</v-icon>
              <span class="modal-title-text mr-2">جستجو</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-5">
          <v-row>
            <v-col cols="12">
              <v-autocomplete :items="allVehiclesForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined clearable
                clear-icon="mdi-close-circle-outline" item-text="code" item-value="id" label="وسیله نقلیه"
                v-model="searchVehicleId" autocomplete="off" prepend-inner-icon="mdi-car-emergency mdi-18px"
                style="font-size: 11px !important"></v-autocomplete>
            </v-col>
            <v-col cols="12" class="mt-n6">
              <v-autocomplete :items="technesiansList" no-data-text="اطلاعاتی وجود ندارد" dense outlined clearable
                clear-icon="mdi-close-circle-outline" item-text="fullName" item-value="id" label="کاربر ارشد"
                v-model="searchSeniorTechnicianId" autocomplete="off" prepend-inner-icon="mdi-account mdi-18px"
                style="font-size: 11px !important"></v-autocomplete>
            </v-col>
            <v-col cols="12" class="mt-n6">
              <v-autocomplete :items="technesiansList" no-data-text="اطلاعاتی وجود ندارد" dense outlined clearable
                clear-icon="mdi-close-circle-outline" item-text="fullName" item-value="id" label="کاربر ارشد قبلی"
                v-model="searchPreviousSeniorTechnicianId" autocomplete="off" prepend-inner-icon="mdi-account mdi-18px"
                style="font-size: 11px !important"></v-autocomplete>
            </v-col>
            <v-col cols="12" class="mt-n6">
              <v-autocomplete :items="drugShortageCounts" no-data-text="اطلاعاتی وجود ندارد" dense outlined clearable
                clear-icon="mdi-close-circle-outline" item-text="drugTitle" item-value="drugId" label="دارو"
                v-model="searchDrugId" autocomplete="off" prepend-inner-icon="mdi-pill mdi-18px"
                style="font-size: 11px !important"></v-autocomplete>
            </v-col>
            <v-col cols="12" class="mt-n6">
              <v-autocomplete :items="notSelectedItemsCounts" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id"
                label="آیتم انتخاب نشده" v-model="searchNotSelectedCategoryItemId" autocomplete="off"
                prepend-inner-icon="mdi-text-box mdi-18px" style="font-size: 11px !important"></v-autocomplete>
            </v-col>
            <v-col cols="12" class="mt-n6">
              <v-autocomplete :items="isActiveSearchItems" no-data-text="اطلاعاتی وجود ندارد" dense outlined clearable
                clear-icon="mdi-close-circle-outline" item-text="title" item-value="id" label="وضعیت"
                v-model="searchIsActive" autocomplete="off" prepend-inner-icon="mdi-text mdi-18px"
                style="font-size: 11px !important"></v-autocomplete>
            </v-col>
            <v-col cols="12" class="mt-n6">
              <v-text-field type="text" outlined id="user-moveFromStationTime" ref="moveFromStationTime" dense clearable
                autocomplete="off" @click:clear="clearDateTime('searchFromDate')" clear-icon="mdi-close-circle-outline"
                v-model="tempSearchFromDate" @focus="showSearchFromDate = true" @click="showSearchFromDate = true"
                label="از تاریخ" prepend-inner-icon="mdi-calendar-range mdi-18px">
                <template slot="append">
                  <v-icon @click="showSearchFromDate = true" class="calender-background ml-n3 mt-n2" color="white">
                    mdi-calendar-range mdi-18px
                  </v-icon>
                </template>
              </v-text-field>
              <date-picker :show="showSearchFromDate" simple v-model="searchFromDate" type="datetime" @open="onOpen"
                @change="dateTimeChange('searchFromDate')" :editable="true" format="YYYY-MM-DDTHH:mm:ss"
                display-format="HH:mm:ss jYYYY/jMM/jDD" custom-input="#moveFromStationTime-moveFromStationTime"
                @close="showSearchFromDate = false" />
            </v-col>
            <v-col cols="12" class="mt-n6">
              <v-text-field type="text" outlined id="user-arriveToLocationTime" ref="arriveToLocationTime" dense
                autocomplete="off" clearable @click:clear="clearDateTime('searchToDate')"
                clear-icon="mdi-close-circle-outline" v-model="tempSearchToDate" @focus="showSearchToDate = true"
                @click="showSearchToDate = true" label="تا تاریخ" prepend-inner-icon="mdi-calendar-range mdi-18px">
                <template slot="append">
                  <v-icon @click="showSearchToDate = true" class="calender-background ml-n3 mt-n2" color="white">
                    mdi-calendar-range mdi-18px
                  </v-icon>
                </template>
              </v-text-field>
              <date-picker :show="showSearchToDate" simple type="datetime" @open="onOpen" v-model="searchToDate"
                @change="dateTimeChange('searchToDate')" :editable="true" format="YYYY-MM-DDTHH:mm:ss"
                display-format="HH:mm:ss jYYYY/jMM/jDD" custom-input="#arriveToLocationTime-arriveToLocationTime"
                @close="showSearchToDate = false" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="search()" dark rounded class="normal-letter-spacing px-12">
            جستجو
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelSearch()" class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="tableImg.val">
          <v-row>
            <v-col cols="3">
              <v-img :src="tableTitleImage.val" contain max-height="14vh" max-width="27vh">
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content">گزارشات ثبت شده</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
            <v-col cols="1" class="mr-n16">
              <v-btn class="mx-2 mt-3 mr-n16" fab dark small @click="backToDashboard()" color="darkColor" elevation="0">
                <v-icon dark>mdi-arrow-right mdi-18px</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="3" class="mr-n11">
              <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense
                v-model="searchTitle" class="mt-3 mr-n16"></v-text-field>
            </v-col>
            <v-col cols="1" class="mr-n3">
              <v-btn class="mx-2 mt-3 mr-n16" fab dark small @click="showSearchModal()" color="darkColor" elevation="0">
                <v-icon dark>mdi-filter mdi-18px</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="1" class="mr-n16 mt-6" v-if="isSearch">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon light v-bind="attrs" v-on="on" @click="removeFilters()" class="mr-n16">
                    mdi-filter-remove mdi-18px
                  </v-icon>
                </template>
                <span>حذف فیلتر ها</span>
              </v-tooltip>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="1" class="mt-3">
              <v-btn @click="
                exportToExcel(
                  allCheckListTableHeader,
                  allCheckListTableItems,
                  'text',
                  `all_check-list_report_page_${page}`,
                )
                " fab dark small color="darkColor" elevation="0">
                <v-icon dark>mdi-file-excel mdi-18px</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters class="background-main mx-2">
            <v-col cols="12">
              <v-card elevation="0" class="card-width body-card">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <template>
                        <v-data-table hide-default-header :headers="allCheckListTableHeader"
                          :items="allCheckListTableItems" :page.sync="page"
                          :items-per-page="allCheckListTableItems.length" height="62vh" :hide-default-footer="true"
                          multi-sort :search="searchTitle" class="elevation-0">
                          <template v-slot:header="props">
                            <app-group-table-header :headers="props.props.headers" @sort="props.on.sort"
                              @group="props.on.group" />
                          </template>
                          <template v-slot:[`item.actions`]="{ item }">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1" color="iconColor" style="cursor: pointer"
                                  @click="goToDetail(item.id)" v-bind="attrs" v-on="on">
                                  mdi-text-box
                                </v-icon>
                              </template>
                              <span>جزئیات</span>
                            </v-tooltip>
                          </template>
                          <template v-slot:no-data>
                            <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                          </template>
                        </v-data-table>
                      </template>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <pagination-component ref="pagination">
                <div slot="action">
                  <v-card elevation="0">
                    <v-pagination class="mt-8" circle v-model="page" color="lightColor" :length="totalPages"
                      :total-visible="8" :value="totalPages" prev-icon="mdi-chevron-left" next-icon="mdi-chevron-right"
                      @next="next()" @previous="previous()" @input="input()"></v-pagination>
                  </v-card>
                </div>
              </pagination-component>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import AlertComponent from '@/components/AlertComponent.vue';
import PaginationComponent from '@/components/PaginationComponent.vue';
import AppGroupTableHeader from '@/components/app/table/groupableHeader.vue';
import ExcelHelper from '@/Helpers/Excel.generator.helper';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import pagination from '@/Mixins/Pagination';
import QcAllCheckListsHelper from '@/Helpers/QC/QcAllCheckListsHelper.js';
import UserMixin from '@/Mixins/BaseInformation/UserMixin.js';
import CheckListMixin from '@/Mixins/BaseInformation/CheckListMixin.js';
import VehicleMixin from '@/Mixins/BaseInformation/VehicleMixin.js';
import Vue from 'vue';
export default {
  name: 'QcAllCheckListReport',
  title: 'گزارشات ثبت شده',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    AlertComponent,
    PaginationComponent,
    AppGroupTableHeader,
  },
  mixins: [
    pagination,
    ShearedMixin,
    snackBar,
    ShearedHelper,
    QcAllCheckListsHelper,
    UserMixin,
    CheckListMixin,
    VehicleMixin,
    ExcelHelper,
  ],
  created() {
    this.$root.$refs.QcAllCheckListReport = this;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {};
  },
  methods: {
    mounte: function () {
      if (this.$route.params.id) {
        let route = this.$route.params.id.split('_');
        if (route[0] == 1) {
          this.searchDrugId = route[1];
        } else if (route[0] == 2) {
          this.searchNotSelectedCategoryItemId = route[2];
        }
      }
      // this.$refs.pagination.newPageSize = 10;
      // this.$refs.pagination.pageSize = 10;
      if (!this.isRelatedToDrugOrOnSelectedItems) this.setPreTimes();
      this.getListOfCheckListsWithPaginationFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchVehicleId,
        this.searchSeniorTechnicianId,
        this.searchPreviousSeniorTechnicianId,
        this.searchDrugId,
        this.searchNotSelectedCategoryItemId,
        this.searchIsActive,
        this.page,
        this.pageSize,
      );
      this.getDrugShortageCountFunction();
      this.getNotSelectedItemsCountFunction();
      this.getAllTechniciansFunction();
      this.getListOfVehiclesForOther();
    },
    setPreTimes: function () {
      this.tempSearchFromDate = '00:00:00 ';
      let temp = Vue.moment().format('jYYYY-jMM-jDD');
      this.tempSearchFromDate += temp;
      this.searchFromDate = Vue.moment().format('YYYY-MM-DD');
      this.searchFromDate += 'T00:00:00';
      this.searchToDate = Vue.moment().format('YYYY-MM-DDTHH:mm:ss');
      this.tempSearchToDate = Vue.moment().format('HH:mm:ss jYYYY-jMM-jDD');
    },
    previous: function () {
      this.getListOfCheckListsWithPaginationFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchVehicleId,
        this.searchSeniorTechnicianId,
        this.searchPreviousSeniorTechnicianId,
        this.searchDrugId,
        this.searchNotSelectedCategoryItemId,
        this.searchIsActive,
        this.page,
        this.pageSize,
      );
      this.$refs.pagination.page = this.page;
    },
    next: function () {
      this.getListOfCheckListsWithPaginationFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchVehicleId,
        this.searchSeniorTechnicianId,
        this.searchPreviousSeniorTechnicianId,
        this.searchDrugId,
        this.searchNotSelectedCategoryItemId,
        this.searchIsActive,
        this.page,
        this.pageSize,
      );
      this.$refs.pagination.page = this.page;
    },
    input: function () {
      this.getListOfCheckListsWithPaginationFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchVehicleId,
        this.searchSeniorTechnicianId,
        this.searchPreviousSeniorTechnicianId,
        this.searchDrugId,
        this.searchNotSelectedCategoryItemId,
        this.searchIsActive,
        this.page,
        this.pageSize,
      );
      this.$refs.pagination.page = this.page;
    },
  },
};
</script>
<style scoped>
.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.card-add-phoneNumber {
  border: 2px solid #cdcbcf !important;
}

.card-add-phoneNumber-items {
  margin-top: -7px !important;
}

.card-add-phoneNumber-items-text {
  color: #cdcbcf !important;
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}
</style>
